import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private hubConnection: signalR.HubConnection;
  private connectionActive = false;
  private logsSubject = new BehaviorSubject<string[]>([]);
  private allLogs: string[] = [];
  private maxLogLines = 5000; 

  constructor(private env: EnvironmentService) {}

  get logs$(): Observable<string[]> {
    return this.logsSubject.asObservable();
  }

  startConnection(): void {
    if (this.connectionActive) return;

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.env.envVariables.httpProtocol}${this.env.envVariables.webHost}logHub`)
      .withAutomaticReconnect([0, 2000, 10000, 30000])
      .build();

    this.hubConnection.start()
      .then(() => {
        this.connectionActive = true;
        this.setupLogListener();
      })
      .catch(err => {
        console.error('Error while starting connection: ' + err);
        setTimeout(() => this.startConnection(), 5000);
      });
  }

  private setupLogListener(): void {
    this.hubConnection.on('ReceiveMessage', (log: string) => {
      if (!log) return;
      
      // Split new logs by lines and add to array
      const newLines = log.split('\n').filter(line => line.trim());
      this.allLogs.push(...newLines);
      
      // Keep only recent logs to prevent memory issues
      if (this.allLogs.length > this.maxLogLines) {
        this.allLogs = this.allLogs.slice(-this.maxLogLines);
      }
      
      // Emit updated logs
      this.logsSubject.next([...this.allLogs]);
    });
  }

  stopConnection(): void {
    if (this.hubConnection) {
      this.hubConnection.stop()
        .then(() => {
          this.connectionActive = false;
        })
        .catch(err => console.error('Error while stopping connection: ' + err));
    }
  }

  clearLogs(): void {
    this.allLogs = [];
    this.logsSubject.next([]);
  }
}